import { Fragment, useContext, useState } from "react";
import { useNavigate } from "react-router";
import { Button } from "rizzui";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import cn from "../../../utils/classNames";
import UsersList from "./UsersList";

const UsersListWrapper = () => {

    // STATES

    const [openFormDrawer, setOpenFormDrawer] = useState<boolean>(false);
    const [userSelected, setUserSelected] = useState<any | null>(null);

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Control de acceso' },
        { name: 'Usuarios', href: menuRoutes.users.path },
    ];

    // HOOKS

    const { userCan } = useContext(PrivilegeContext);
    const navigate = useNavigate();

    // RENDER

    return (
        <Fragment>
            <FiltersProvider>
                <PageHeader title="Listado de usuarios" breadcrumb={breadCrumb}>
                    {
                        userCan('create', 'user') &&
                        (
                            <Button
                                color="primary"
                                onClick={() => { 
                                    setOpenFormDrawer(true) 
                                    setUserSelected(null)
                                }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear usuario
                            </Button>
                        )
                    }
                </PageHeader>
                <UsersList openFormDrawer={openFormDrawer} setOpenFormDrawer={setOpenFormDrawer} userSelected={userSelected} setUserSelected={setUserSelected} />
            </FiltersProvider>
        </Fragment>
    );
}

export default UsersListWrapper;